import { FetchResult, MutationFunctionOptions, useMutation } from '@apollo/client';

import {
  evictCache,
  GenerateRdProjectsReportMutation,
  GenerateRdProjectsReportMutationVariables,
  GENERATE_RD_PROJECTS_REPORT,
} from '@neo.tax/shared';

export const useGenerateRdProjectsReport = (): {
  generateRdProjectsReport: (
    options?: MutationFunctionOptions<GenerateRdProjectsReportMutation, GenerateRdProjectsReportMutationVariables>,
  ) => Promise<FetchResult<GenerateRdProjectsReportMutation>>;
  loading: boolean;
  called: boolean;
} => {
  const [generateRdProjectsReport, { called, loading }] = useMutation<
    GenerateRdProjectsReportMutation,
    GenerateRdProjectsReportMutationVariables
  >(GENERATE_RD_PROJECTS_REPORT, {
    update: (cache) => {
      evictCache(cache, ['getBackgroundOperations']);
    },
  });

  return {
    generateRdProjectsReport,
    loading,
    called,
  };
};
